import React from "react";

function Footer() {
  return (
    <div className="footer fixed-bottom">
      <h6>
        Artography &copy; 2022 .
        <span style={{ color: "#17d2d9ff", textDecoration: "none" }}>
          Developed by{" "}
          <a
            style={{ color: "#17d2d9ff", textDecoration: "none" }}
            href="http://linkedin.com/in/praveen-s-662509198"
            target="_blank"
            rel="noreferrer"
          >
            Praveen
          </a>{" "}
        </span>
      </h6>
    </div>
  );
}

export default Footer;
